import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, map, of, tap } from 'rxjs';
import { GtcGQL} from 'src/generated/graphql';
import { completeData } from '@app/_helpers/apollo';

@Component({
    selector: 'app-gtc',
    templateUrl: './gtc.component.html',
    styleUrls: ['./gtc.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GtcComponent implements OnInit {

  gtc$: Observable<any> = of();
  constructor(private gtcGql: GtcGQL) { }

  ngOnInit(): void {
    this.gtc$ = this.gtcGql.watch().valueChanges.pipe(
      completeData(),
      map(response => {
        return (response.data.gtc)
      })
    )
  }

}